import { render, staticRenderFns } from "./headerContainer.vue?vue&type=template&id=08475898&scoped=true"
import script from "./headerContainer.vue?vue&type=script&lang=js"
export * from "./headerContainer.vue?vue&type=script&lang=js"
import style0 from "./headerContainer.vue?vue&type=style&index=0&id=08475898&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08475898",
  null
  
)

export default component.exports